<template>
  <div class="intro-y box p-5">
    <!-- Name field -->
    <div>
      <label :for="`form-name`" class="form-label font-medium">
        {{ $t(`${viewRoot}.form.name.label`) }}
      </label>
      <div class="input-group">
        <input
          id="form-name"
          type="text"
          class="form-control w-full bg-theme-32"
          :class="localData.validations.name && 'border border-theme-6'"
          :placeholder="$t(`${viewRoot}.form.name.placeholder`)"
          v-model="localData.name"
          :disabled="readOnly"
        />
      </div>
      <div v-if="localData.validations.name" class="text-theme-6 mt-2 text-sm">
        {{ localData.validations.name }}
      </div>
    </div>

    <!-- Region of origin field -->
    <div class="mt-6">
      <label :for="`form-region`" class="form-label font-medium">
        {{ $t(`${viewRoot}.form.region.label`) }}
      </label>
      <div class="input-group input-bg-theme-32 rounded relative">
        <TomSelect
          id="form-region"
          class="w-full cursor"
          v-model="localData.regionOfOrigin"
          :class="localData.validations.regionOfOrigin && 'border border-theme-6'"
          :placeholder="$t(`${viewRoot}.form.region.placeholder`)"
          :disabled="readOnly"
          :plugins="['dropdown_input']"
        >
          <option value="WESTERN">Western / Occidente</option>
          <option value="EASTERN">Eastern / Oriente</option>
        </TomSelect>
      </div>
      <div v-if="localData.validations.regionOfOrigin" class="text-theme-6 mt-2 text-sm">
        {{ localData.validations.regionOfOrigin }}
      </div>
    </div>

    <!-- Link Page field -->
    <div class="mt-6">
      <label :for="`form-link`" class="form-label font-medium">
        {{ $t(`${viewRoot}.form.link.label`) }}
      </label>
      <div class="input-group">
        <input
          id="form-link"
          type="url"
          class="form-control w-full bg-theme-32"
          :class="localData.validations.linkPage && 'border border-theme-6'"
          :placeholder="$t(`${viewRoot}.form.link.placeholder`)"
          v-model="localData.linkPage"
          :disabled="readOnly"
        />
      </div>
      <div v-if="localData.validations.linkPage" class="text-theme-6 mt-2 text-sm">
        {{ localData.validations.linkPage }}
      </div>
    </div>
  </div>
</template>

<script>
import { ensureShape } from "@/utils/modules/science-source/platforms.js";

export default {
  name: "ScienceSourcePlatformsModule",
  props: {
    modelValue: { type: Object, required: true },
    readOnly: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      viewRoot: "views.science_source_platforms",
      localData: ensureShape(this.modelValue),
      syncingModel: false,
    };
  },
  watch: {
    modelValue: {
      deep: true,
      handler(val) {
        if (this.syncingModel) return;
        const next = ensureShape(val);
        if (JSON.stringify(next) !== JSON.stringify(this.localData)) {
          this.localData = next;
        }
      },
    },
    localData: {
      deep: true,
      handler(val) {
        this.syncingModel = true;
        this.$emit("update:modelValue", JSON.parse(JSON.stringify(val)));
        this.$nextTick(() => {
          this.syncingModel = false;
        });
      },
    },
  },
};
</script>
